import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ScopeSelector } from '@bingads-webui-react/scope-selector';
import { getLevel, setLevel, TargetingLevel } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { getLevelItems, SelectorLevels } from '@bingads-webui-campaign-react/shell-ui-common';
import { withCheckCampaignWithScope } from './check-campaign-wrapper';

import { navigateToTargetLevel } from './utils';

class LevelSelectorWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      switchLevel: false,
    };
  }

  componentDidUpdate() {
    if (this.state.switchLevel) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        switchLevel: false,
      });
    }
  }

  OnLevelChange({ index }) {
    const {
      scope,
      urls,
      levelItems,
    } = this.props;
    const selectedItem = levelItems[index];

    let level = TargetingLevel.Campaign;
    if (selectedItem.value === SelectorLevels.Campaign) {
      level = TargetingLevel.Campaign;
    } else if (selectedItem.value === SelectorLevels.AdGroup) {
      level = TargetingLevel.AdGroup;
    }

    setLevel(level, true);
    this.setState({ switchLevel: true });
    navigateToTargetLevel(level, scope, urls);
  }

  render() {
    const {
      scope,
      component,
      levelItems,
    } = this.props;

    const selectedLevel = getLevel(scope.values.adGroupId, true);

    const levelIndex = levelItems.findIndex(item =>
      (selectedLevel === TargetingLevel.AdGroup && item.value === SelectorLevels.AdGroup) ||
      (selectedLevel === TargetingLevel.Campaign && item.value === SelectorLevels.Campaign));

    const levelSelector = scope.values.adGroupId > 0 ?
      null :
      (
        <ScopeSelector
          pillControlParams={{
            levelIndex,
            onItemChange: ({ index }) => this.OnLevelChange({ index }),
            levelItems,
          }}
        />
      );
    const Component = component;
    return (
      <Fragment>
        {levelSelector}
        <Component {...this.props} selectedLevel={selectedLevel} switchLevel={this.state.switchLevel} />
      </Fragment>
    );
  }
}

LevelSelectorWrapper.propTypes = {
  scope: PropTypes.shape({
    values: {
      adGroupId: PropTypes.number,
      campaignId: PropTypes.number,
    },
  }),
  component: PropTypes.elementType.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  urls: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentCampaign: PropTypes.shape({}).isRequired,
  checkCampaign: PropTypes.bool,
  levelItems: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number,
  })),
};

LevelSelectorWrapper.defaultProps = {
  scope: {},
  checkCampaign: false,
  levelItems: [],
};

export const DefaultLevelSelectorWrapper = (props) => {
  const {
    i18n,
  } = props;

  const levelItems = getLevelItems({ i18n });
  return (<LevelSelectorWrapper {...props} levelItems={levelItems} />);
};

DefaultLevelSelectorWrapper.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

export const LevelSelectorWrapperWithCheckCampaign = withCheckCampaignWithScope(LevelSelectorWrapper);
